import { type CaptureLogger } from '../ports/logger';
import { getConfiguredLoggerBase } from './configuration';

const createDelegatingLogger = (resolveTarget: () => CaptureLogger): CaptureLogger => ({
  trace: (...args) => resolveTarget().trace(...args),
  debug: (...args) => resolveTarget().debug(...args),
  info: (...args) => resolveTarget().info(...args),
  warn: (...args) => resolveTarget().warn(...args),
  error: (...args) => resolveTarget().error(...args),
  fatal: (...args) => resolveTarget().fatal(...args),
  log: (...args) => resolveTarget().log(...args),
  child: (bindings) => {
    // Children are delegating facades too: derived lazily and re-derived only
    // when the base is swapped, so construction-time captures keep following
    // reconfiguration while each child is still built once.
    let derivedFrom: CaptureLogger | null = null;
    let derived: CaptureLogger | null = null;
    return createDelegatingLogger(() => {
      const parent = resolveTarget();
      if (derived === null || derivedFrom !== parent) {
        derivedFrom = parent;
        derived = parent.child(bindings);
      }
      return derived;
    });
  },
});

// The seam the engine logs through. Root consumers use the base as-is; the
// recording store derives the `audio-recording` child and the graph store the
// `audio-graph` child, keeping the three logging categories independent.
export const captureLogger: CaptureLogger = createDelegatingLogger(
  getConfiguredLoggerBase
);
